<template>
    <div>
        <div v-if="dataFetch" class="page-content">
            <div class="container-fluid">
                <div class="card border">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="mr-3 w-100">
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <div class="skeleton-bar">
                                            <div class="sb-md sb-thin mb-2"></div>
                                            <div class="sb-md sb-thin mb-2"></div>
                                            <div class="sb-md sb-thin mb-4"></div>

                                            <div class="sb-md sb-thin mb-2"></div>
                                            <div class="sb-lg sb-thin mb-2"></div>
                                            <div class="sb-lg sb-thin mb-4"></div>

                                            <div class="sb-md sb-thin mb-2"></div>
                                            <div class="sb-lg sb-thin mb-2"></div>
                                            <div class="sb-lg sb-thin mb-4"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dataFetch" class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 class="mb-sm-0">Hasil - {{dataDetail.title}}</h4>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-top:-10px !important">
                    <div class="col-md-8 col-sm-12">
                        <div class="card border">
                            <div class="card-body">
                                <h4 class="card-title">Informasi Latihan</h4>
                                <p class="card-title-desc">Berikut ini adalah informasi latihan yang telah kamu kerjakan :</p>
                                <table class="table table-centered mb-3">
                                    <tbody>
                                        <tr>
                                            <td style="vertical-align:top !important" class="col-sm-4"><i class="mdi mdi-clipboard-file-outline"></i> Nama Latihan</td>
                                            <td class="col-sm-8">
                                                <b>{{dataDetail.title}}</b>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style="vertical-align:top !important" class="col-sm-4"><i class="mdi mdi-clock-check-outline"></i> Durasi Soal</td>
                                            <td class="col-sm-8">
                                                <b>{{dataDetail.timer}} Menit</b>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style="vertical-align:top !important" class="col-sm-4"><i class="mdi mdi-clipboard-list-outline"></i> Tanggal Mengerjakan</td>
                                            <td class="col-sm-8">
                                                <b>{{dataDetail.working_date}}</b>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style="vertical-align:top !important" class="col-sm-4"><i class="mdi mdi-account-check-outline"></i> Nama Peserta</td>
                                            <td class="col-sm-8">
                                                <b>{{dataDetail.participant_name}}</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="dataDetail.graduated == 0" class="alert alert-danger fade show" role="alert">
                                    Hallo <b>{{dataDetail.participant_name}}!</b><br/>
                                    <b>Kamu belum sempurna pada latihan ini.</b><br/>
                                    Tetap semangat dan coba lagi kembali di latihan berikutnya yaaa...<br/>
                                </div>

                                <div v-if="dataDetail.graduated == 1" class="alert alert-success fade show" role="alert">
                                    Hallo <b>{{dataDetail.participant_name}}!</b><br/>
                                    <b>Selamat kamu mendapatkan nilai sempurna pada latihan ini!</b> Jangan sampai berpuas diri ya!<br/>
                                    Tetap konsisten & coba lagi kembali latihan berikutnya...<br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="card border">
                            <div class="card-body text-center">
                                <h4 class="card-title">Total Skor Kamu</h4>
                                <h2 class="mt-3"><b>{{dataDetail.total_scored}}</b></h2>
                                <h3><b>Dari {{dataDetail.total_points}}</b></h3>
                                <hr/>
                                <h4 class="card-title">Keterangan</h4>
                                <h4 v-if="dataDetail.graduated == 0"><span class="badge bg-danger">Belum sempurna</span></h4>
                                <h4 v-if="dataDetail.graduated == 1"><span class="badge bg-success">Nilai Sempurna</span></h4>

                                <small class="card-title-desc text-center">Klik tombol dibawah untuk melihat hasil dan statistik latihan kamu</small>
                                
                                <div class="d-grid">
                                    <button v-on:click="changeTab('Statistic')" type="button"  :class="currentTabComponent == 'Statistic' ? 'btn-primary':'btn-outline-primary'" class="text-left btn rounded btn-block mt-2" ><i class="mdi mdi-chart-bar"></i> Lihat Statistik</button>
                                    <button v-on:click="changeTab('Discussion')" type="button" :class="currentTabComponent == 'Discussion' ? 'btn-primary':'btn-outline-primary'" class="text-left btn rounded btn-block mt-2" ><i class="mdi mdi-clipboard-file-outline"></i> Lihat Pembahasan</button>
                                    <button v-on:click="changeTab('Progress')" type="button" :class="currentTabComponent == 'Progress' ? 'btn-primary':'btn-outline-primary'" class="text-left btn rounded btn-block mt-2" ><i class="mdi mdi-chart-line"></i> Progress Belajar</button>
                                    <button v-on:click="confirmStartExercises" type="button" class="text-left btn btn-outline-primary rounded btn-block mt-2" ><i class="mdi mdi-book-edit-outline"></i> Kerjakan Ulang</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <vue-page-transition>
                    <keep-alive>
                        <component :is="currentTabComponent"></component>
                    </keep-alive>
                </vue-page-transition>
            </div>
        </div>
    </div>
</template>

<script>
    import Statistic from "@/views/member/cpns/exercises/Statistic.vue"
    import Discussion from "@/views/member/cpns/exercises/Discussion.vue"
    import Progress from "@/views/member/cpns/exercises/Progress.vue"

    export default {
        name: 'MemberCpnsexercisesResultDetail',
        metaInfo: {
            title: 'Statistik & Hasil Latihan CPNS',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        components: {
            Statistic,
            Discussion,
            Progress
        },
        data() {
            return {
                emptyState                  : false,
                dataFetch                   : false,
                dataDetail                  : [],
                currentTabComponent         : 'Statistic',
                cpns_exercises_answer_id    : this.$route.params.cpns_exercises_answer_id,
                premium                     : 0
            }
        },
        created() {
            this.getData();
        },
        methods: {
            changeTab: function(tabActive, enable=true) {
                if(enable) {
                    this.currentTabComponent = tabActive;
                }
            },
            getData: function() {
                let uri         = process.env.VUE_APP_APIHOST+'member/cpns/exercises/result/detail';

                this.dataFetch  = true;                
                this.$http.get(uri,{
                    params : {
                        cpns_exercises_answer_id : this.cpns_exercises_answer_id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        this.dataFetch  = false;
                        this.dataDetail = res.data.data;
                        this.premium    = res.data.premium;
                    } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: res.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.goBack();
                            }
                        });
                    }
                });
            },
            goBack: function() {
                this.$router.push({ name: 'member_cpns_exercises_result'});
            },
            confirmStartExercises: function() {
                this.$swal({
                    icon: 'info',
                    title: 'Konfirmasi',
                    html: 'Apakah kamu yakin akan mulai mengerjakan soal?',
                    confirmButtonText: 'Iya',
                    showCancelButton: true,
                    cancelButtonText: 'Batal',
                }).then((result) => {
                    if (result.value) {
                        this.$router.push({ name: 'member_cpns_exercises_overview' , params: {
                            code : this.dataDetail.code
                        }});
                    }
                });
            },
        }
    }
</script>